<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    slide: {
      type: Object,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["watchVideo"]),
    videoInfo() {
      return {
        url: this.slide.videoUrl,
        poster: this.slide.poster,
        vimeoId: this.slide.vimeoId,
      };
    },
  },
  methods: {
    ...mapActions(["toggleModal"]),


  },
};
</script>
<template>
  <div :class="{ active: active === slide.id }" class="tab">
    <h2 class="tab-title heading-4">
      <!-- <img
          v-if="typeof slide.icon !== `undefined`"
          :src="slide.icon"
          loading="lazy"
          alt=""
          class="tab-icon"
        /> -->
      {{ slide.title }}
    </h2>
    <p class="tab-description">
      {{ slide.description }}
      <a v-if="typeof videoInfo.vimeoId !== `undefined`" @click.prevent="toggleModal(videoInfo)" href="#"
        class="learnMore">
        {{ watchVideo }}
      </a>
      <ProductIndicator v-if="
        typeof slide.products !== 'undefined' && slide.products.length > 0
      " :active-products="slide.products" class="vw-component-indicator" />
    </p>
  </div>
</template>

<style lang="scss" scoped>
.tab {
  --icon-size: 65px;
  --description-color: #575756;
  display: flex;
  flex-direction: column;
  padding: var(--tab-padding);
  transition: all 0.3s ease-in-out;
  color: var(--text-color);

  &:last-child {
    margin-bottom: 0;
  }
}

.vw-darkest-surface {
  .tab {
    --description-color: var(--text-color);
  }
}

.vw-dark-surface {
  .tab {
    --description-color: var(--text-color);
  }

  .active {
    background-color: #252525;
  }
}

.active {
  background: transparent;
  box-shadow: 2px 2px 10px 2px var(--shadow-color);
  border-radius: 5px;
  transform: translate3d(0, -5px, 0);
  background-color: #fdfdfd;
}

.tab-icon {
  width: var(--icon-size);
  height: var(--icon-size);
  margin-right: 20px;
  object-fit: cover;
  border-radius: var(--icon-border-radius);
}

.tab-title {
  display: flex;
  align-items: flex-end;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.5;
}

.tab-description {
  text-align: left;
  font-size: 16px;
  letter-spacing: 0.16px;
  line-height: 1.6;
  color: var(--description-color);
  font-weight: 300;
}

.tab-video-link {
  font-weight: 500;
}

.iconGroup {
  margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppIconTab.vue